function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.549 3.409h-6.183L14.562.772c-.004-.294-.108-.506-.31-.634s-.476-.156-.821-.083l-2.616 3.354h-1.63L6.57.055c-.323-.095-.59-.067-.803.083a.755.755 0 00-.328.634l2.195 2.637H1.451c-.8 0-1.451.677-1.451 1.51V18.49C0 19.323.65 20 1.451 20h17.098c.8 0 1.451-.677 1.451-1.51V4.918c0-.832-.65-1.51-1.451-1.51zm-4.524 13.27c0 .454-.353.821-.788.821H3.143c-.436 0-.789-.367-.789-.82V6.73c0-.454.353-.821.789-.821h10.094c.435 0 .788.367.788.82v9.95zm2.92-.377a1.37 1.37 0 01-1.37-1.366 1.37 1.37 0 012.738 0 1.37 1.37 0 01-1.369 1.366zm0-6.577a1.37 1.37 0 01-1.37-1.367 1.37 1.37 0 012.738 0 1.37 1.37 0 01-1.369 1.367z"
});

function SvgTvShows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgTvShows;